import React from "react";
import Image01 from "src/assets/images/new-plane.svg";
import Image02 from "src/assets/images/new-clipboard.svg";
import Image03 from "src/assets/images/new-profile.svg";
import Image04 from "src/assets/images/new-oscar.svg";
import Image05 from "src/assets/images/new-gaurdian.svg";
import Image06 from "src/assets/images/new-documents.svg";
import Image07 from "src/assets/images/new-contact.svg";
import Image08 from "src/assets/images/new-invoice.svg";
import Image from "src/components/elements/Image";

const DashboardTiles = ({ onTileClick }) => {
  const tiles = [
    { label: "Book a new trip", image: Image01, id: "book" },
    { label: "My Travel Requests", image: Image02, id: "requests" },
    { label: "Traveller Profile", image: Image03, id: "profile" },
    { label: "Oscar", image: Image04, id: "oscar" },
    { label: "Travel Guardian", image: Image05, id: "guardian" },
    { label: "Company documents", image: Image06, id: "documents" },
    { label: "Invoices", image: Image08, id: "invoices" },
    { label: "Contact us", image: Image07, id: "contact" },
  ];

  return (
    <>
      <h2 className="mb-4 text-2xl font-extrabold text-[#2D0B31]">Your Travel Tools</h2>
      <div className="flex flex-col items-start">
        {tiles?.length > 0 && (
          <div className="flex w-full flex-col items-center gap-4">
            <div className="flex w-full gap-4">
              {tiles?.map((item, index) => (
                <button
                  key={index}
                  onClick={() => onTileClick(item.id)}
                  className="flex aspect-square w-full flex-shrink flex-grow flex-col items-center justify-around rounded-lg bg-[#2D0B31] px-4 py-4 transition-all duration-300 hover:shadow-lg hover:shadow-[#2D0B31]/25">
                  <div className="flex aspect-square w-16 items-center justify-center">
                    <Image
                      src={item?.image}
                      alt={item?.label}
                      width={"100%"}
                      height={"100%"}
                      effect={"blur"}
                      classes={"object-cover"}
                    />
                  </div>
                  <div className="text-center text-base leading-tight text-white">{item?.label}</div>
                </button>
              ))}
            </div>
            <div className="text-sm font-semibold text-slate-500">Plan and track your business travel effortlessly.</div>
          </div>
        )}
      </div>
    </>
  );
};

export default DashboardTiles;
